angular.module('cfn').factory('cfnGridSorting', [
  'propertySupport',
  function(propertySupport) {
    var service = {};

    service.init = function(scope, element, attrs) {
      var serviceInstance = {};

      serviceInstance.onGridInit = function() {
        scope.view.sorted = [];

        var defaultColumnObj = getSortObjByCookieStr(getDefaultCookieStr()),
          modeStr;

        if (!defaultColumnObj.col) {
          // if there is no defaultsort to apply -> don't sort
          return;
        }

        modeStr = modeObjToStr({
          sorted: defaultColumnObj.sorted,
          sortedReversed: defaultColumnObj.sortedReversed
        });

        sort(defaultColumnObj.col, modeStr, false);
      };

      serviceInstance.applySort = function(model) {
        var standardSortFN = function(a, b) {
          var result = 0;
          var reversed = sortspec && sortspec[0].reversed;

          //First sort by selected sorting key (e.g. 'name'), THEN sort by id
          var sortspec = scope.view.sorted.concat([
            { col: 'number', type: 'number', reversed: true }, // catalogue items have no number hence will be shown later in the list
            { col: 'id', type: 'text', reversed: reversed }
          ]);
          sortspec.forEach(function(sort) {
            if (result == 0) {
              var aVal = propertySupport.deepGet(a, sort.col);
              var bVal = propertySupport.deepGet(b, sort.col);

              if (sort.type === 'innerHtml') sort.type = typeof aVal;

              switch (sort.type || 'text') {
                case 'number':
                  aVal = Number(aVal) || 0;
                  bVal = Number(bVal) || 0;
                  break;
                case 'date':
                  aVal = aVal || 0;
                  bVal = bVal || 0;
                  break;
                case 'text':
                  aVal = aVal || '';
                  bVal = bVal || '';
                  break;
                default:
                  if (aVal === true || aVal === 'true') aVal = -1;
                  if (bVal === true || bVal === 'true') bVal = -1;
              }

              if (typeof aVal === 'string' && typeof bVal === 'string') {
                result = alphanum(aVal.toLowerCase(), bVal.toLowerCase());
              } else {
                if (aVal < bVal) {
                  result = -1;
                } else if (aVal > bVal) {
                  result = 1;
                } else {
                  result = 0;
                }
              }

              if (sort.reversed) {
                result *= -1;
              }
            }
          });
          return result;
        };

        if (scope.view.sorted.length >= 1) {
          return model.sort(standardSortFN);
        } else {
          return model;
        }
      };

      serviceInstance.toggleSortCol = function(column) {
        var curSortModeStr, nextSortModeStr;

        if (!column.sortable) {
          return;
        }

        curSortModeStr = modeObjToStr({
          sorted: column.sorted,
          sortedReversed: column.sortedReversed
        });
        nextSortModeStr = toggleModeStr(curSortModeStr);

        sort(column, nextSortModeStr, true);
      };

      serviceInstance.getSortedColumns = function() {
        return angular.copy(scope.view.sorted);
      };

      serviceInstance.setSortedColumns = function(sortingData) {
        _.each(sortingData, function(sortedColumn) {
          var modeStr = modeObjToStr({
            sorted: sortedColumn.sorted,
            sortedReversed: sortedColumn.reversed
          });
          sort(sortedColumn.column, modeStr, false);
        });
      };

      function sort(column, mode, doImmidiatelyUpdate) {
        var sortModeObj = modeStrToObj(mode);

        setSortOnColumns(
          column,
          sortModeObj.sorted,
          sortModeObj.sortedReversed
        );

        setViewScopeProps(column, mode);

        if (doImmidiatelyUpdate) {
          scope.updateView(scope.datasource());
          saveCookieSortmode(column);
        }
      }

      function setViewScopeProps(column, mode) {
        var isReversed;

        if (mode === 'ASC' || mode === 'DESC') {
          isReversed = mode === 'DESC';

          // set sort mode properties

          scope.view.sorted = [
            {
              col: column.name,
              type: column.type,
              reversed: isReversed
            }
          ];

          scope.view.liveSorted = column.name; // until solr sorts we use angular sort
          scope.view.liveSortedReversed = isReversed;
        } else {
          // reset

          scope.view.sorted = [];
          scope.view.liveSorted = '';
          scope.view.liveSortedReversed = false;
        }
      }

      function resetScopeProps(column) {
        scope.view.sorted = [];
        scope.view.liveSorted = '';
        scope.view.liveSortedReversed = false;
      }

      function setSortOnColumns(toBeSortedColumn, sorted, sortedReversed) {
        $.each(scope.columns, function(k, v) {
          if (v === toBeSortedColumn) {
            // set new sort mode
            v.sorted = sorted;
            v.sortedReversed = sortedReversed;
          } else {
            // reset on other columns
            v.sorted = false;
            v.sortedReversed = false;
          }
        });
      }

      function toggleModeStr(modeStr) {
        //toggle between Ascending/Descending/None
        switch (modeStr) {
          case 'ASC':
            return 'DESC';
            break;
          case 'DESC':
            return 'NONE';
            break;
          case 'NONE':
            return 'ASC';
            break;
        }
      }

      function modeObjToStr(modeObj) {
        //toggle between Ascending/Descending/None
        switch (true) {
          case modeObj.sorted && !modeObj.sortedReversed:
            return 'ASC';
            break;
          case modeObj.sorted && modeObj.sortedReversed:
            return 'DESC';
            break;
          case !modeObj.sorted:
            return 'NONE';
            break;
        }
      }

      function modeStrToObj(mode) {
        //toggle between Ascending/Descending/None
        switch (mode) {
          case 'ASC':
            return {
              sorted: true,
              sortedReversed: false
            };
          case 'DESC':
            return {
              sorted: true,
              sortedReversed: true
            };
          case 'NONE':
            return {
              sorted: false,
              sortedReversed: false
            };
        }
      }

      function getDefaultCookieStr() {
        // returns e.g. "name:DESC"
        var validCookie = getCookieSortmode(),
          defaultSort;

        if (validCookie) {
          defaultSort = validCookie; // Prio 1 Cookie
        } else if (scope.defaultsortcolumn) {
          defaultSort = scope.defaultsortcolumn; // Prio 2 In HTML-Template configured default sort
        } else {
          defaultSort = ''; // Prio 3 no sorting at all
        }

        return defaultSort;
      }

      // returns sortObj ({colName: "/name of column/", col: "/the actual column model/", isReversed: "true/false")

      function getSortObjByCookieStr(sortStr) {
        var hasColonInString = sortStr.indexOf(':') != -1,
          sortColName = hasColonInString
            ? sortStr.substr(0, sortStr.indexOf(':'))
            : sortStr;

        return {
          col: _.findWhere(scope.columns, { name: sortColName }),
          sorted: true,
          sortedReversed: sortStr.indexOf(':DESC') != -1
        };
      }

      function getCookieSortmode(column) {
        if (scope.cookieName) {
          var userSet = getCookie(scope.cookieName);
          if (userSet && userSet != '') return userSet;
        }

        //else
        return '';
      }

      function saveCookieSortmode(column) {
        var sortCookieStr;

        if (!scope.cookieName) {
          // if there has been no cookiename specified to save sort settings in, then don't
          return false;
        }

        if (column.sorted) {
          // newly sorted
          sortCookieStr =
            column.name + ':' + (column.sortedReversed ? 'DESC' : 'ASC');
        } else {
          sortCookieStr = '';
        }

        setCookie(scope.cookieName, sortCookieStr);
      }

      return serviceInstance;
    };

    return service;
  }
]);
